import React, { useState } from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../hooks/useRouter';
import Urls from '../profile/Urls';
import DataCard from './DataCard';
import useUserTags from '../../hooks/useUserTags';
import TagTypes from '../../constants/TagTypes';

export default function Ages(props) {
  const { user } = props;

  const { history } = useRouter();

  const [timestamp] = useState(new Date().toISOString());

  const userAges = useUserTags(user, TagTypes.Age, timestamp);

  let subtitle = '';

  if (userAges.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = userAges.data.map(function(userAge, index) {
      return (
        <div key={index}>
          {userAge._tag.data.name}
        </div>
      );
    });
  }

  return (
    <DataCard
      title="Student Age Groups"
      icon={UsersIcon}
      subtitle={subtitle || '(not provided)'}
      onClick={() => history.push(Urls(user).AGES)}
    />
  );
};
